import React, { useEffect, useState } from "react";
import { CustomButton, FilterBar, TableData, TxnLogView } from "../../components";
import { BugReport, MoveDown } from '@mui/icons-material';
import { useDispatch, useSelector } from "react-redux";
import { downloadDetailedReportLecarozService, downloadDetailedReportService, getCatalogsDetailedReportService, getDetailedReportService } from "../../services/report/reportService";
import { setDetailedReportFilters } from "../../redux/slices/report/reportSlice";
import { errorAlert } from "../../helpers/alerts";
import moment from "moment";
import { compareObjects, currencyFormatter, downloadFile } from "../../helpers/util";
import ColumnFilterModal from "../../components/modal/ColumnFilterModal";
import { getLogsTxnService, getTxnBackupService } from "services/panelService";
import { setTitle } from "redux/slices/uiSlice";
import DialogModal from "../../components/modal/DialogModal";
import { Box, Table } from "@mui/material";
import { Loader } from "rsuite";
import Image from "components/common/Image";
import Images from "assets/images";
import { useLocation, useNavigate } from "react-router-dom";
import { getGroupsService } from "services/client/groupService";
import { setGroups } from "redux/slices/client/groupSlice";


const BackupScreen = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { detailedReportFilters } = useSelector((store) => store.reports);
  const { type } = useSelector(store => store.session);
  const [detailedReport, setDetailedReport] = useState([])
  const [total, setTotal] = useState(0)
  const [loadingTable, setLoadingTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  const columns = [
    { category: 'Destino', name: "type", label: "Tipo", format: ({ bag }) => bag?.type },
    { category: 'Destino', name: "typeTxn", label: "Movimiento", format: ({ etagSaldo, typeReg }) => ['ABONO', 'COMISION', 'ABONO_COMISION', 'ABONO_DESCUENTO'].includes(typeReg) ? etagSaldo : ['TAE', 'PDS', 'PIN'].includes(typeReg) ? `VENTA (${typeReg})` : '-' },
    { category: 'Destino', name: "operator", label: "Operadora", format: ({ operator }) => operator },
    { category: 'Destino', name: "phone", label: "Telefono", format: ({ phoneNumber, typeReg, reference, referenceSaldo, operacionOrigen }) => (typeReg == 'PDS' || operacionOrigen) ? (reference || referenceSaldo || '-') : ['TAE', 'PIN'].includes(typeReg) ? (phoneNumber || '-') : '-' },
    { category: 'Destino', name: "segment", label: "Segmento", format: ({ productType }) => productType },
    { category: 'Destino', name: "import", label: "Importe", sort: ({ typeReg, amount, operacionSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? parseFloat(amount) : parseFloat(operacionSaldo), format: ({ typeReg, amount, operacionSaldo }) => currencyFormatter.format(['TAE', 'PDS', 'PIN'].includes(typeReg) ? amount : operacionSaldo) },
    { category: 'Destino', name: "reference", label: "Referencia", format: ({ typeReg, ProviderReference, referenceSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? ProviderReference : referenceSaldo },
    { category: 'Destino', name: "region", label: "Región", format: ({ region }) => region },
    { category: 'Saldo', name: "prevBalance", label: "Anterior", format: ({ saldoAnterior }) => saldoAnterior ? currencyFormatter.format(saldoAnterior) : '' },
    { category: 'Saldo', name: "operacionSaldo", label: "Debitado", format: ({ operacionSaldo }) => currencyFormatter.format(operacionSaldo) },
    { category: 'Saldo', name: "currentBalance", label: "Actual", format: ({ saldoActual }) => saldoActual ? currencyFormatter.format(saldoActual) : '' },
    type == 'admin' && { category: 'Saldo', name: "discount_porcent", label: "% Descuento", format: ({ discount_porcent }) => discount_porcent ? `${discount_porcent}%` : '' },
    type == 'admin' && { category: 'Saldo', name: "discount_applied", label: "Descuento", format: ({ discount_applied }) => discount_applied ? currencyFormatter.format(discount_applied) : '' },
    { category: 'Resultado', name: "state", label: "Estado", format: ({ typeReg, ProviderResponseCode }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? ProviderResponseCode != "00" ? 'DENEGADA' : 'APROBADA' : '' },
    { category: 'Resultado', name: "message", label: "Mensaje", format: ({ typeReg, ProviderResponseMessage, ProviderResponseCode }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) && ProviderResponseCode != '00' ? ProviderResponseMessage : '' },
    { category: 'Resultado', name: "code", label: "Codigo", format: ({ ProviderResponseCode }) => ProviderResponseCode },
    { category: 'Resultado', name: "datetime", label: "Fecha y hora", sort: ({ createdAt }) => createdAt, format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    { category: 'Resultado', name: "auth", label: "Autorización", format: ({ AuthCode }) => AuthCode },
    { category: 'Resultado', name: "time", label: "Tiempo", format: ({ time }) => `${time} ms` },
    { category: 'Entidad', name: "commerceId", label: "ID Comercio", format: ({ commerceIdentification }) => commerceIdentification },
    { category: 'Entidad', name: "commerce", label: "Comercio", format: ({ commerce }) => commerce },
    { category: 'Entidad', name: "salepoint", label: "Punto de Venta", format: ({ salepoint }) => salepoint },
    type == 'admin' && { category: 'Entidad', name: "provider", label: "Proveedor", format: ({ serviceName }) => serviceName },
    { category: 'Entidad', name: "user", label: "Usuario", format: ({ user }) => user?.nameUser },
    { category: 'Entidad', name: "primaryProvider", label: "Proveedor Principal", format: ({ primaryProvider }) => primaryProvider },
    { category: 'Entidad', name: "timePrimaryProvider", label: "Tiempo Proveedor Principal", format: ({ primaryProviderResponseTime }) => `${primaryProviderResponseTime.toFixed(2)} s` },
    { category: 'Entidad', name: "secondaryProvider", label: "Proveedor Secundario", format: ({ secundaryProvider }) => secundaryProvider },
    { category: 'Entidad', name: "timeSecondaryProvider", label: "Tiempo Proveedor Secundario", format: ({ endTxn, updatedAt, createdAt }) => `${(((endTxn || updatedAt) - createdAt) / 1000).toFixed(2)} s` },

  ].filter(Boolean);
  const [selectedColumns, setSetSelectedColumns] = useState([
    "operator",
    "phone",
    "import",
    "code",
    "datetime",
    "primaryProvider",
    "secondaryProvider",
    "timePrimaryProvider",
    "timeSecondaryProvider"
  ])

  useEffect(() => {
    dispatch(setTitle('Aprobadas Backup'));
    // eslint-disable-next-line
    return () => {
      dispatch(setDetailedReportFilters(null))
    }
  }, []);

  const handlerSubmit = async (data) => {
    if (location.state) {
      data = location.state;
      navigate(location.pathname, { replace: true, state: null });
    }
    if (!compareObjects(data, detailedReportFilters)) {
      dispatch(setDetailedReportFilters(data))
    }
    setLoadingTable(true)
    getDetailedReportService(selectedColumns, {
      ...data,
      backup: 1,
      page,
      limit
    }).then((result) => {
      setDetailedReport(result.data)
      setTotal(result.total)
    }).catch((error) => errorAlert(error))
      .finally(() => setLoadingTable(false));
  }

  const handlerDownload = async () => {
    setLoading(true)
    downloadDetailedReportService(selectedColumns, detailedReportFilters)
      .then((data) => downloadFile(data, 'Reporte Detallado.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(25)

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={limit}
        // showButton={true}
        defaultValues={{
          type: 1,
          state: 1,
          backup: 1,
          date: [new Date(), new Date()],
        }}
        allValue={null}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
        ]}
      />
      <Box mt={-5} >
        <TableData
          filters={detailedReportFilters}
          loading={loadingTable}
          onChangePage={setPage}
          onChangeRowsPerPage={setLimit}
          sorteableData={data => data.map(item => {
            columns.filter(({ name }) => selectedColumns.includes(name)).map(({ name, format, sort }) => item[`_${name}_`] = sort ? sort(item) : format(item))
            return item
          })}
          total={total}
          dataRows={detailedReport.map((item) => ({
            ...item,
            style: item.ProviderResponseCode != "00" && ['TAE', 'PDS', 'PIN'].includes(item.typeReg) && { color: 'red' }
          }))}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={Images.icon.download}
              key="dowloadDetails"
              name={"Descargar"}
              loading={loading}
              click={handlerDownload}
            />
          ]}
          dataTitle={columns.filter(({ name }) => selectedColumns.includes(name))}
          formatter={(data) => columns.filter(({ name }) => selectedColumns.includes(name)).map(({ format }) => format(data))}
          actions={[
            {
              label: "Logs",
              icon: <BugReport />,
              onClick: async (data) => {
                const result = await getLogsTxnService(data._id);
                setDialog({
                  open: true,
                  maxWidth: 'lg',
                  title: `Log Transacción ${data._id}`,
                  textAlign: 'left',
                  body: <TxnLogView data={result} />,
                  onClose: () => setDialog({ open: false })
                })
              },
            },
          ]}
        />
      </Box>
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  );
};

export default BackupScreen;
